<template>
    <el-container direction="vertical" class="rating">
        <el-row class="rating-header">
            <el-col :span="24">
                <div class="page-title bold fnt-lg dark text-left">
                    Доходность сделки
                </div>
            </el-col>
        </el-row>
        <el-row>
            <deal-profit-grid />
        </el-row>
    </el-container>
</template>

<script>
import '@/assets/styles/card.scss';
import '@/assets/styles/card-complex.scss';
import DealProfitGrid from '@/views/analytics/deal/DealProfitGrid';

export default {
    name: 'DealProfit',
    data() {
        return {
        };
    },
    components: {
        DealProfitGrid
    },
    computed: {
    }
};
</script>
